import { render, staticRenderFns } from "./DialogDeleteFolder.vue?vue&type=template&id=2bf9b4e5&"
import script from "./DialogDeleteFolder.vue?vue&type=script&lang=js&"
export * from "./DialogDeleteFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports